<div style="display:flex;margin:5px;">

    <fa-icon [icon]="faSpinner" size="4x" [spin]="true"></fa-icon>
  </div>
  